import axios from "axios/index";
/**
 * 查询充电站
 * @param params
 * @returns {Promise<any | {code: number, message: string}>}
 */
export const getList = params => axios.post('/business/chargingStation/list', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

export const create = params => axios.post('/business/chargingStation/add', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

export const update = params => axios.post('/business/chargingStation/update', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

export const del = id => axios.post('/business/chargingStation/delete', {id}).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

export const detail = id => axios.post('/business/chargingStation/detail', {id}).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

/**
 * 状态
 * @param className 参数
 * @return {Promise<AxiosResponse<any>>}
 */
export const status = params => axios.post('/business/chargingStation/status', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

/**
 * 查询充电站列表
 * @param className 参数
 * @return {Promise<AxiosResponse<any>>}
 */
export const getChargingStationList = params => axios.post('/business/chargingStation/chargingStationList', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});



